import React from 'react'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { message } from 'antd'
import { setUserData } from '../../Components/Redux/actions'
import { useDispatch } from 'react-redux'

export default function GoogleSignup() {
  const params = useParams()
  const navigate = useNavigate()
  const { token } = params
  const dispatch = useDispatch()

  useEffect(() => {
    getSocialResponse()
  }, [])

  const getSocialResponse = () => {
    try {
      let logedInData = JSON.parse(atob(token))
      console.log(logedInData)
      if (logedInData.error) {
        message.destroy()
        message.error(logedInData?.message || 'Something went wrong in google login')
        navigate('/login')
      } else {
        let userRes = { user: logedInData?.data?.user }
        userRes.user.sessionToken = logedInData?.data?.token
        let user = JSON.stringify(userRes)
        dispatch(setUserData(user))
        navigate('/dashboard')
        message.destroy()
        message.success('Login Succesfully !!')
      }
    } catch (error) {
      // message.destroy()
      // message.error(error.message || 'Error found in google login')
      navigate('/login')
    }
  }

  return <></>
}
